module.exports = "/_next/static/images/row1-3-2x-911750129093b72ca4b3e2bf074778b6.png";